<div v-bind:class="getClassName">
  <div class="matrix_selectOptionName"><span>{{name}} <appTooltip v-if="tooltip" :tooltip="tooltip"></appTooltip></span>
  <span v-if="getIsCimpressDefaultSelection">
    <label>
      <input type="checkbox" :checked="isHiddenInFrontend" @change="hidePageOptionInFrontend($event)" />
      {{ $t("Hide in frontend") }}
    </label>
  </span>
  </div>
  <Select2
    v-model="value"
    :options="options"
    :settings="settings"
    :id="getId"
  />
  <input v-if="showColorPickerForOption" id="margin_color_input" v-on:change="proccessMarginColor" type="color" :value="getMarginColor" style="width:100%; cursor: pointer;">
</div>
